import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f2ceb326&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=f2ceb326&prod&scoped=true&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=f2ceb326&prod&scoped=true&lang=scss&"
import style2 from "./detail.vue?vue&type=style&index=2&id=f2ceb326&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ceb326",
  null
  
)

export default component.exports